module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._l((_vm.list), function(item, k) {
    return _c('div', {
      key: k
    }, [_c('el-divider', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.name == '过往经历') ? _c('div', [_c('el-collapse', {
      model: {
        value: (_vm.activeIndex),
        callback: function($$v) {
          _vm.activeIndex = $$v
        },
        expression: "activeIndex"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "title": "过往经历",
        "name": "过往经历"
      }
    }, [(item.date.zhicai.length) ? _c('div', [_c('el-divider', [_vm._v("执裁记录")]), _vm._v(" "), _vm._l((item.date.zhicai), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [_c('van-cell', {
        attrs: {
          "title": "赛区名称",
          "value": row.saiqu_name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "裁判长",
          "value": row.cpz
        }
      })], 1)
    })], 2) : _vm._e(), _vm._v(" "), (item.date.huiyi.length) ? _c('div', [_c('el-divider', [_vm._v("培训记录")]), _vm._v(" "), _vm._l((item.date.huiyi), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [_c('van-cell', {
        attrs: {
          "title": "名称",
          "value": row.name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "场次名称",
          "value": row.stationname
        }
      })], 1)
    })], 2) : _vm._e(), _vm._v(" "), (item.date.cansai.length) ? _c('div', [_c('el-divider', [_vm._v("参赛记录")]), _vm._v(" "), _vm._l((item.date.cansai), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [_c('van-cell', {
        attrs: {
          "title": "赛区名称",
          "value": row.saiqu_name
        }
      })], 1)
    })], 2) : _vm._e()])], 1)], 1) : _c('div', [(item.list.length) ? _c('div', _vm._l((item.list), function(row, i) {
      return _c('van-cell-group', {
        key: i
      }, [(item.name == '裁判资质') ? _c('div', [_c('div', {
        staticClass: "cert-li"
      }, [_c('div', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_vm._v(_vm._s(row.cert.filename))]), _vm._v(" "), _c('div', {
        staticClass: "cert-li-img"
      }, [(row.cert.img) ? _c('img', {
        attrs: {
          "src": row.cert.img,
          "alt": ""
        }
      }) : _vm._e(), _vm._v(" "), (row.cert.img2) ? _c('img', {
        attrs: {
          "src": row.cert.img2,
          "alt": ""
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "cert-button"
      }, [_c('el-button', {
        staticStyle: {
          "margin": "10px auto",
          "text-align": "center"
        },
        attrs: {
          "type": "default",
          "round": ""
        },
        on: {
          "click": function($event) {
            return _vm.download(row.name + '-' + row.grade, row.cert.url)
          }
        }
      }, [_vm._v("点击下载\n                    ")])], 1)])]) : (item.name == '执裁记录') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "赛区",
          "value": row.match_name
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "裁判长",
          "value": row.admin_name
        }
      })], 1) : (item.name == '培训记录') ? _c('div', [_c('van-cell', {
        attrs: {
          "title": "日期",
          "value": row.date
        }
      }), _vm._v(" "), _c('van-cell', {
        attrs: {
          "title": "名称",
          "value": row.name
        }
      })], 1) : _vm._e()])
    }), 1) : _c('div', {
      staticStyle: {
        "text-align": "center",
        "padding": "10px",
        "margin": "0 10px",
        "background": "#fff",
        "border-radius": ".2rem"
      }
    }, [_vm._v("系统中暂无记录\n          ")])])], 1)
  }), _vm._v(" "), (_vm.emptyShow) ? _c('div', {}, [_c('van-empty', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "description": "暂无结果"
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'SaiScoreCaipanApply'
      }),
      expression: "{name: 'SaiScoreCaipanApply'}"
    }]
  }, [_vm._v("补交执裁记录")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertPersonPhoto'
      }),
      expression: "{name: 'CertPersonPhoto'}"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("上传证件照\n        ")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d46e381","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/UserSearchCaipan.vue
// module id = 1471
// module chunks = 0